module.exports = __webpack_public_path__ + "static/img/方案背景@3x.76103d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/方案背景@3x.png
// module id = XJp3
// module chunks = 192